import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import Dashboard from "./components/AdminDashboard/AdminDashboard";
import ManagerDashboard from "./components/ManagerDashboard/ManagerDashboard";
import SupportDashboard from "./components/SupportDashboard/SupportDashboard";
import Approval from "./components/AdminDashboard/Newregistration/Approval";
import Add from "./components/AdminDashboard/Newregistration/Add";
import Active from "./components/AdminDashboard/ViewPublishers/Active";
import Inactive from "./components/AdminDashboard/ViewPublishers/Inactive";
import {
  Marketactive,
  Marketinactive,
} from "./components/AdminDashboard/viewMarketers";
import Viewrevenue from "./components/AdminDashboard/Viewrevenue";
import Mangactive from "./components/ManagerDashboard/Viewpublisher/Active";
import Manginactive from "./components/ManagerDashboard/Viewpublisher/Inactive";
import Markactive from "./components/ManagerDashboard/Viewmarketer/Active";
import Markinactive from "./components/ManagerDashboard/Viewmarketer/Inactive";
import Resetpassword from "./components/ManagerDashboard/Customersupport/Resetpassword";
import Answerticket from "./components/ManagerDashboard/Customersupport/Answerticket";
import ModifyInfo from "./components/ManagerDashboard/ModifyInformation";
import Modifyadmin from "./components/AdminDashboard/Modifyinformation";
import Answer from "./components/SupportDashboard/Customersupport/Answerticket";
import Reset from "./components/SupportDashboard/Customersupport/MarketerResetpassword";
import Custactive from "./components/SupportDashboard/Viewmarketer/Active";
import Custinactive from "./components/SupportDashboard/Viewmarketer/Inactive";
import Pubactive from "./components/SupportDashboard/Viewpublisher/Active";
import Pubinactive from "./components/SupportDashboard/Viewpublisher/Inactive";
import { useState } from "react";
import { LoginAuthContext } from "./context/auth";
import ViewApproval from "./components/AdminDashboard/Newregistration/View-approval";
import Publisherreset from "./components/ManagerDashboard/Customersupport/Publisherreset";
import PublisherResetPassword from "./components/SupportDashboard/Customersupport/PublisherResetPassword";
import ViewActive from "./components/AdminDashboard/ViewPublishers/Edit-active";

function App() {
  const [AdminLoginState, setAdminLoginState] = useState(" ");
  return (
    <div className="App">
      {console.log(AdminLoginState)}
      <Router>
        <Routes>
          {/*  */}
          <Route
            path="/"
            element={
              <LoginAuthContext.Provider value={{ setAdminLoginState }}>
                <LoginForm />
              </LoginAuthContext.Provider>
            }
          />
          {/*  */}
          {AdminLoginState === "admin" ? (
            //  Admin router starts
            <Route path="/admin" element={<Dashboard />}>
              <Route path="revenue" element={<Viewrevenue />} />
              <Route path="mod-info" element={<Modifyadmin />} />
              <Route path="new-reg">
                <Route path="approve">
                  <Route path="" element={<Approval />} />
                  <Route path="view/:mpi_id" element={<ViewApproval />} />
                </Route>
                <Route path="add" element={<Add />} />
              </Route>
              <Route path="publisher">
                <Route path="active">
                  <Route path="" element={<Active />} />
                  <Route path="edit/:mpi_id" element={<ViewActive />} />
                </Route>
                <Route path="inactive" element={<Inactive />} />
              </Route>
              <Route path="marketer">
                <Route path="active" element={<Marketactive />} />
                <Route path="inactive" element={<Marketinactive />} />
              </Route>
            </Route>
          ) : //  Admin router ends
          AdminLoginState === "manager" ? (
            // manager route starts
            <Route path="/manager" element={<ManagerDashboard />}>
              <Route path="mod-info" element={<ModifyInfo />} />
              <Route path="publisher">
                <Route path="active" element={<Mangactive />} />
                <Route path="inactive" element={<Manginactive />} />
              </Route>
              <Route path="marketer">
                <Route path="active" element={<Markactive />} />
                <Route path="inactive" element={<Markinactive />} />
              </Route>
              <Route path="cus-sup">
                <Route path="resetpassword" element={<Resetpassword />} />
                <Route path="answerticket" element={<Answerticket />} />
                <Route path="pubresetpassword" element={<Publisherreset />} />
              </Route>
            </Route>
          ) : // manager route ends
          AdminLoginState === "support" ? (
            // support route starts
            <Route Route path="/support" element={<SupportDashboard />}>
              <Route path="cust-sup">
                <Route path="answerticket" element={<Answer />} />
                <Route path="marresetpassword" element={<Reset />} />
                <Route
                  path="pubresetpassword"
                  element={<PublisherResetPassword />}
                />
              </Route>
              <Route path="marketer">
                <Route path="active" element={<Custactive />} />
                <Route path="inactive" element={<Custinactive />} />
              </Route>
              <Route path="publisher">
                <Route path="active" element={<Pubactive />} />
                <Route path="inactive" element={<Pubinactive />} />
              </Route>
            </Route>
          ) : // support route ends
          null}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
